import mixCutDetailStore from "@/stores/mixCutDetailStore";
import { ICaption } from "@/stores/mixCutDetailStore/type/caption";
import useMixCutDetailSave from "./useMixCutDetailSave";
import { initCaptionItem } from "@/stores/mixCutDetailStore/init";
import useTitle from "./useTitle";
import usePreviewConfig from "../preview/usePreview";
import ConfigStore from "@/stores/mixedConfig";
interface IUseCaptionReturn {
  projectCaption: ICaption[][];
  handleProjectCaptionToIndexChange: (
    groundIndex: number,
    index: number,
    caption: ICaption,
    disPreview?: boolean,
  ) => void;
  handleProjectCaptionItemAddItem: (groupIndex: number) => void;
  handleProjectCaptionChange: (captions: ICaption[][]) => void;
  handleSwapCaptionItem: (destination: number, source: number) => void;
  handleCaptionItemDelete: (index: number) => void;
  handleCaptionItemAdd: () => void;
  hanldeProjectCaptionItemDeleteItem: (group: number, index: number) => void;
  handleCaptionVoiceIsGlobalToChangeTrue: (
    groudIndex: number,
    index: number,
  ) => void;
  handleCaptionTextIsGlobalToChangeTrue: (
    groundInde: number,
    index: number,
  ) => void;
  hanldeCaptionTextSettingGlobleChange: (
    groudIndex: number,
    index: number,
    is_global: boolean,
  ) => void;
}

const useCaption = (): IUseCaptionReturn => {
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { handlePreviewCaptionChange } = usePreviewConfig();
  const handleProjectCaptionChange = (captions: ICaption[][]) => {
    mixCutDetailStore.setProjectCaption(captions);
    handleSaveMixCutDetailSave();
  };

  const handleProjectCaptionToIndexChange = (
    groudIndex: number,
    index: number,
    caption: ICaption,
    disPreview?: boolean,
  ) => {
    const captions = [...mixCutDetailStore.getProjectCaption()];
    captions[groudIndex][index] = caption;
    mixCutDetailStore.setProjectCaption(captions);
    if (caption.voice_setting.is_global === true) {
      handleCaptionVoiceIsGlobalToChangeTrue(groudIndex, index);
    }
    if (caption.text_setting.is_global === true) {
      handleCaptionTextIsGlobalToChangeTrue(groudIndex, index);
    }
    if (!disPreview) {
      handlePreviewCaptionChange(caption);
    }

    handleSaveMixCutDetailSave();
  };

  // 添加台词组，台词小组
  const handleProjectCaptionItemAddItem = (group: number) => {
    const captions = [...mixCutDetailStore.getProjectCaption()];
    captions[group] = [
      ...captions[group],
      {
        ...initCaptionItem,
        id: Math.floor(Date.now() + Math.random() * 10000),
      },
    ];
    mixCutDetailStore.setProjectCaption([...captions]);
    ConfigStore.scenes[group].caption.push({
      ...initCaptionItem,
      id: Math.floor(Date.now() + Math.random() * 10000),
    });
    handleSaveMixCutDetailSave();
  };

  const hanldeProjectCaptionItemDeleteItem = (group: number, index: number) => {
    const captions = [...mixCutDetailStore.getProjectCaption()];
    captions[group].splice(index, 1);
    mixCutDetailStore.setProjectCaption([...captions]);
    // 修改caption
    ConfigStore.scenes[group].caption.splice(index, 1);
    handleSaveMixCutDetailSave();
  };

  const handleSwapCaptionItem = (destination: number, source: number) => {
    const captions = mixCutDetailStore.getProjectCaption();
    // [captions[destination], captions[source]] = [
    //   captions[source],
    //   captions[destination],
    // ];
    const [caption] = captions.splice(source, 1);
    captions.splice(destination, 0, caption);
    mixCutDetailStore.setProjectCaption(captions)
    captions.forEach((item, index) => {
      ConfigStore.scenes[index].caption = item;
    });
    // mixCutDetailStore.setProjectCaption([...captions]);
    handleSaveMixCutDetailSave();
  };

  const handleCaptionItemDelete = (index: number) => {
    const newCaptionList = [...mixCutDetailStore.getProjectCaption()];
    newCaptionList.splice(index, 1);
    mixCutDetailStore.setProjectCaption(newCaptionList);
  };

  const handleCaptionItemAdd = () => {
    const newCaptionList = [...mixCutDetailStore.getProjectCaption()];
    newCaptionList.push([
      {
        id: Math.floor(Date.now() + Math.random() * 100000),
        ...initCaptionItem,
      },
    ]);
    mixCutDetailStore.setProjectCaption([...newCaptionList]);
    handleSaveMixCutDetailSave();
  };

  const handleCaptionVoiceIsGlobalToChangeTrue = (
    groudIndex: number,
    index: number,
  ) => {
    const newCaptionList = [...mixCutDetailStore.getProjectCaption()];
    const voiceSetting = newCaptionList[groudIndex][index].voice_setting;
    newCaptionList.forEach((item) => {
      item.forEach((step) => {
        step.voice_setting = {
          ...voiceSetting,
          is_global: step.voice_setting.is_global,
        };
      });
    });
    mixCutDetailStore.setProjectCaption(newCaptionList);
    ConfigStore.scenes[groudIndex].caption = newCaptionList[groudIndex];
    handleSaveMixCutDetailSave();
  };

  const hanldeCaptionTextSettingGlobleChange = (
    groupIndex: number,
    index: number,
    e: boolean,
  ) => {
    if (e) {
      mixCutDetailStore.getProjectCaption()[groupIndex][
        index
      ].text_setting.is_global = true;
      const { x, y } =
        mixCutDetailStore.getProjectCaption()[groupIndex][index].text_setting;
      mixCutDetailStore.getProjectCaption().forEach((captionGroup) => {
        captionGroup.forEach((caption) => {
          caption.text_setting.x = x;
          caption.text_setting.y = y;
        });
      });
    } else {
      mixCutDetailStore.getProjectCaption()[groupIndex][
        index
      ].text_setting.is_global = false;
    }
    mixCutDetailStore.setProjectCaption([
      ...mixCutDetailStore.getProjectCaption(),
    ]);
  };

  const handleCaptionTextIsGlobalToChangeTrue = (
    groudIndex: number,
    index: number,
  ) => {
    const newCaptionList = [...mixCutDetailStore.getProjectCaption()];
    const voiceSetting = newCaptionList[groudIndex][index].text_setting;
    newCaptionList.forEach((item) => {
      item.forEach((step) => {
        step.text_setting = {
          ...voiceSetting,
          is_global: step.text_setting.is_global,
        };
      });
    });
    mixCutDetailStore.setProjectCaption(newCaptionList);
    handleSaveMixCutDetailSave();
  };

  return {
    projectCaption: mixCutDetailStore.getProjectCaption(),
    handleProjectCaptionItemAddItem,
    hanldeProjectCaptionItemDeleteItem,
    handleProjectCaptionChange,
    handleProjectCaptionToIndexChange,
    handleSwapCaptionItem,
    handleCaptionItemDelete,
    handleCaptionItemAdd,
    handleCaptionVoiceIsGlobalToChangeTrue,
    handleCaptionTextIsGlobalToChangeTrue,
    hanldeCaptionTextSettingGlobleChange,
  };
};

export default useCaption;
